/**
 * WorkspaceCodeView — lazy-loaded syntax-highlighted code/text viewer (view-only).
 *
 * highlight.js auto-detects the language across 190+ grammars. Code-split (see
 * AgentWorkspaceBrowser) so the highlighter + grammars load only when a code
 * file is opened. Falls back to plain text if highlighting fails.
 */
import React, { useMemo } from 'react';
import hljs from 'highlight.js/lib/common';
import 'highlight.js/styles/github.css';

export default function WorkspaceCodeView({ content }) {
  const html = useMemo(() => {
    try {
      return hljs.highlightAuto(content || '').value;
    } catch {
      return null;
    }
  }, [content]);
  return (
    <pre className="hljs flex-1 overflow-auto px-3 py-2 text-[11px] leading-snug"
         data-testid="workspace-code-view">
      {html
        ? <code dangerouslySetInnerHTML={{ __html: html }} />
        : <code className="whitespace-pre">{content}</code>}
    </pre>
  );
}
